<script>
import attachmentService from "@/services/Attachments/attachmentService";
import pessoasService from "@/services/Pessoas/pessoasService";
import ordersService from "@/services/Orders/ordersService";
import financingService from "@/services/Financing/financingService";
import attachmentsService from "@/services/Attachments/attachmentService";
import settingsService from "@/services/Settings/settingsService";
import fiduciaService from "@/services/Fiducia/fiduciaService";
import socinalService from "@/services/Socinal/socinalService";
import VuePDFViewer from "vue-instant-pdf-viewer";

import Vue from "vue";

import moment from "moment";

import { Settings } from "@/firebase/index";

import { DoubleBounce } from "vue-loading-spinner";
import ContratoModelo from "../components/contrato-modelo/ContratoModelo.vue";
import ContratoModeloSocinal from "../components/contrato-modelo/ContratoModeloSocinal.vue";
import TermoUsoModelo from "../components/contrato-modelo/TermoUsoModelo.vue";
import { toNumberSafe, replaceKeywords } from "@/validate/customValidators";
import { generatePDF } from "@/services/Functions/generatePDF";

import { BancarizadorIntegracaoID } from "@/store/cwl_enums";

var extenso = require("extenso");

import { jsPDF } from "jspdf";
import { uuid } from "vue-uuid";

import html2canvas from "html2canvas";

export default {
  name: "terms-of-use",
  props: {
    financing: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    "vue-pdf-viewer": VuePDFViewer,
    DoubleBounce,
    ContratoModelo,
    ContratoModeloSocinal,
    TermoUsoModelo
  },
  data() {
    return {
      attachments: [],
      pdfCache: {},
      page: 1,
      dataAtual: moment().format("DD/MM/YYYY"),
      dt_encerramento: "",
      numPages: 0,
      currentPage: 0,
      pageCount: 0,
      scale: "page-width",
      attachmentsUrl: [],
      visible: false,
      isLoading: true,
      termsAccepted: false,
      submodalidade: process.env.VUE_APP_SUBTYPE,
      hasError: false,
      objetoContratoCCB: {
        ecwl_aporte: {},
        simulacao: {
          parcelas: {}
        },
        ecwl_oferta: {},
        credor: {},
        emitente: {},
        contrato: {},
        procurador: {},
        parcela_irregular: false
      },
      isSocinal: false,
      order_admin: undefined,
      stopControl: false,
      zerar_contrato: false,
      pdfTermosUsoLista: [],

      // Disclaimer
      showDisclaimer: false,
      disclaimerLabelTaxaAdministrativa: "",
      disclaimerLabelValorAportado: "",
      disclaimerLabelValorAporte: "",
      disclaimerLabelValorBrutoConsiderado: "",
      disclaimerValueTaxaAdministrativa: 0,
      disclaimerValueValorAporte: "",
      disclaimerValueValorAportado: "",

      hashAssinatura: "",
      termosParaUpload: 0,
      termosUploaded: 0
    };
  },
  mounted() {
    if (!this.is_admin) {
      this.hashAssinatura = this.generateHashAssinatura();
      this.getDisclaimerTermos();
      this.getAttachments();
    }
  },
  computed: {
    loggedPessoa() {
      return this.$store.getters.getPessoa;
    },
    order() {
      if (this.is_admin) {
        return this.order_admin;
      } else {
        return this.$store.getters.getOrder;
      }
    },
    is_admin() {
      // console.log(this.$route.params);
      return this.$route.params.admin == "13579";
    }
  },
  methods: {
    getCidadefinancing(p_financing) {
      const _cidade =
        typeof p_financing.cidade === "string"
          ? p_financing.cidade || ""
          : p_financing.cidade.nome || "";

      return _cidade;
    },
    getUFfinancing(p_financing) {
      const _uf =
        typeof p_financing.estado === "string"
          ? p_financing.estado
          : p_financing.estado.uf || "";

      return _uf;
    },
    async generatePdfTermoUso() {
      this.pdfTermosUsoLista = [];
      // let ordersSnapshot = await ordersService.getPaidOrders();
      let ordersSnapshotTotal = await ordersService.getPaidAndWithoutTermoUsoPdfOrdersSemLimite();
      let ordersSnapshot = await ordersService.getPaidAndWithoutTermoUsoPdfOrders();
      let that = this;

      console.log(
        "TOTAL DE ORDENS PAGAS E SEM TERMOS: " + ordersSnapshotTotal.size
      );
      console.log("TOTAL DE ORDENS P/ GERAR OS TERMOS: " + ordersSnapshot.size);
      // await ordersSnapshot.docs.map(async snapshot => {
      //   let order = snapshot.data();
      //   order.status_w_has_termo_uso = "Pago_Nao";
      //   await ordersService.update(order.id, order);
      //   i = i + 1;
      //   console.log("ORDENS ATUALIZADAS: " + i);
      // });
      // return;
      await ordersSnapshot.docs.map(async snapshot => {
        let order = snapshot.data();

        if (order.pessoa && order.pessoa.id) {
          /**
           * Pessoa
           */
          let pessoa_id = order.pessoa.id;
          const pessoaFromFirebase = await pessoasService.getPessoa(pessoa_id);
          const pessoa = pessoaFromFirebase.data();

          /**
           * Oferta
           */
          // let financing_id = order.financing_id;
          // const financingFromFirebase = await financingService.findById(financing_id);

          /**
           * Order
           */

          order.user = order.pessoa;
          if (order.item_bkp) {
            order.item = order.item_bkp;
          }

          let dataToUse = moment(order.order_date, "YYYY/MM/DD H:m");
          let data = dataToUse.format("DD/MM/Y");
          let hora = dataToUse.format("H:mm");

          var ip = order.investidor_ip;
          if (!ip || ip == "") {
            ip = "127.0.0.1";
          }
          var hash_assinatura = order.aceite_termos_hash;
          if (!hash_assinatura || hash_assinatura == "") {
            hash_assinatura = fiduciaService.generateHashAssinatura();
          }

          let custom_object = {
            investidor_nome: pessoa.nome,
            investidor_cpf: pessoa.documento.numero,
            data: data,
            hora: hora,
            investidor_email: pessoa.email.email,
            investidor_ip: ip,
            hash_assinatura: hash_assinatura,
            order: order
          };
          console.log(custom_object);
          that.pdfTermosUsoLista.push(custom_object);
        }
      });

      // setTimeout( function () {
      //   that.generatePdfTermoUso();
      // }, 20000);
    },
    async uploadTermoUso_ADMIN(objeto) {
      var pdfString = objeto.pdfString;
      var order = objeto.order;
      // console.log(pdfString);
      if (!pdfString) {
        return;
      }

      var storageRef = "TermosUso/";
      var fileName = "";
      if (order.ccb && order.ccb.simulacao && order.ccb.simulacao.numero_ccb) {
        fileName = order.ccb.simulacao.numero_ccb + "_TermoUso.pdf";
      } else {
        fileName =
          "sem_numero_CCB_" + fiduciaService.generateHash() + "_TermoUso.pdf";
      }
      // return;

      try {
        let response = await attachmentsService.addNewAttachment(
          pdfString,
          fileName,
          storageRef
        );

        order.status_w_has_termo_uso = "Pago_Sim";
        await ordersService.update(order.id, order);
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    async getAttachments() {
      const attachments = await attachmentService.getTermsAttachments();
      const attachmentItems = await attachments.items;

      const { pessoa_id } = this.loggedPessoa;
      const pessoaFromFirebase = await pessoasService.getPessoa(pessoa_id);
      const pessoa = pessoaFromFirebase.data();

      const attachmentsArray = [];
      //Trata inconsistencia de não existencia de valores:
      var investimentosFinancPessoa = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_financeiros
      );
      var rendaBrutaPessoa = toNumberSafe(
        pessoa.dados_complementares?.perfil?.renda_bruta_anual
      );

      await attachmentItems.map(async item => {
        if (
          item.name.toLowerCase() ==
          "ANEXO A À RESOLUÇÃO CVM Nº 88, DE 27 DE ABRIL DE 2022".toLowerCase()
        ) {
          if (
            pessoa.dados_complementares.perfil &&
            investimentosFinancPessoa > 1000000
          ) {
            attachmentsArray.push({
              item: item,
              url: await this.getURL(item.name),
              tipo: "pdf"
            });
          }
        } else if (
          item.name.toLowerCase() ==
          "ANEXO B À RESOLUÇÃO CVM Nº 88, DE 27 DE ABRIL DE 2022".toLowerCase()
        ) {
          if (
            (pessoa.dados_complementares.perfil &&
              rendaBrutaPessoa >= 200000) ||
            investimentosFinancPessoa >= 200000
          ) {
            attachmentsArray.push({
              item: item,
              url: await this.getURL(item.name),
              tipo: "pdf"
            });
          }
        } else if (
          item.name.toLowerCase() ==
          "ANEXO C À RESOLUÇÃO CVM Nº 88, DE 27 DE ABRIL DE 2022".toLowerCase()
        ) {
          if (
            pessoa.dados_complementares.perfil &&
            rendaBrutaPessoa < 200000 &&
            investimentosFinancPessoa < 200000
          ) {
            attachmentsArray.push({
              item: item,
              url: await this.getURL(item.name),
              tipo: "pdf"
            });
          }
        } else {
          attachmentsArray.push({
            item: item,
            url: await this.getURL(item.name),
            tipo: "pdf"
          });
        }
      });

      this.attachments = attachmentsArray;

      await this.getAutoDeclaracao(pessoa);
      await this.getContratoOferta(pessoa);
      await this.getTermosRisco(pessoa);
    },
    async regerarContrato_ADMIN() {
      /**
       * ATENÇÃO!!!
       * Esta função foi criada em Maio/2022, pois tivemos um bug que houveram 4 aportes com o contrato em branco.
       * Então criamos esta função para regerar estes contratos
       *
       * Em 18/07/2022 identificamos que houveram mais contratos em branco. Então alterei essa função para buscar todos os anexos com tamanho inferior a 1MB para reprocessar.
       */
      let that = this;
      const attachments = await attachmentService.getTermsAttachments(
        "ContratosCCB"
      );
      const attachmentItems = await attachments.items;
      this.zerar_contrato = true;

      var whiteDocsFound = 0;
      var whiteDocsRegenerated = 0;
      await attachmentItems.map(async item => {
        let metadata = await item.getMetadata();
        if (metadata.size < 3000000) {
          whiteDocsFound = whiteDocsFound + 1;
          let name = metadata.name;
          let numero_ccb = name.replace("_ContratoCCB.pdf", "");
          let ordersSnapshot = await ordersService.getOrderByNumeroCCB(
            numero_ccb
          );
          await ordersSnapshot.docs.map(async snapshot => {
            let order = snapshot.data();

            if (order.pessoa && order.pessoa.id) {
              if (!that.stopControl) {
                that.stopControl = true;
                /**
                 * Pessoa
                 */
                let pessoa_id = order.pessoa.id;
                const pessoaFromFirebase = await pessoasService.getPessoa(
                  pessoa_id
                );
                const pessoa = pessoaFromFirebase.data();

                /**
                 * Oferta
                 */
                let financing_id = order.financing_id;
                const financingFromFirebase = await financingService.findById(
                  financing_id
                );
                const financing = financingFromFirebase;

                /**
                 * Order
                 */

                order.user = order.pessoa;
                order.item_bkp = order.item;
                order.item = financing;
                order.item.order = {
                  totalValue: order.item_bkp.value
                };

                that.order_admin = order;

                let data = moment(order.order_date, "YYYY/MM/DD H:m");

                var ip = order.investidor_ip;
                if (!ip || ip == "") {
                  ip = "127.0.0.1";
                }

                let custom_object = {
                  pessoa: pessoa,
                  financing: financing,
                  data: data,
                  ip: ip
                };
                await that.makeObjetoContratoCCB(pessoa, custom_object);
              }
              whiteDocsRegenerated = whiteDocsRegenerated + 1;
            }
          });
        }
        // console.log("Contratos em branco encontrados: " + whiteDocsFound);
        console.log(
          "Contratos em branco que podem ser regerados: " + whiteDocsRegenerated
        );
      });
    },
    async getAutoDeclaracao(pessoa) {
      const settingsFromFirebase = await Settings.get();

      var settings = settingsFromFirebase.docs[0].data();
      settings.id = settingsFromFirebase.docs[0].id;

      // attachmentsArray.push({ item: item, url: await this.getURL(item.name), tipo: 'pdf' });

      const settings_termo4A = settings.termos_4a;
      const settings_termo4B = settings.termos_4b;
      const settings_termo4C = settings.termos_4c;

      const razaoSocial = this.financing.dados_complementares.empresa.nome;

      var outrasPlataformas = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_outras_plataformas
      );
      var nestaPlataforma = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_nesta_plataforma
      );
      var investimentosFinancPessoa = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_financeiros
      );
      var rendaBrutaPessoa = toNumberSafe(
        pessoa.dados_complementares?.perfil?.renda_bruta_anual
      );

      const montantePreFormatado = parseFloat(
        outrasPlataformas + nestaPlataforma
      )
        .toFixed(2)
        .replace(".", ",");
      const montante =
        "R$ " +
        montantePreFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      const replacementsDefault = {
        "#data": this.dataAtual,
        "#local": pessoa.endereco.cidade,
        "#nomeInvestidor": pessoa.nome,
        "#cpfInvestidor": pessoa.documento.numero,
        "#razaoSocialEmissor": razaoSocial,
        "#montante": montante
      };
      var termo4A = replaceKeywords(settings_termo4A, replacementsDefault);
      var termo4B = replaceKeywords(settings_termo4B, replacementsDefault);
      var termo4C = replaceKeywords(settings_termo4C, replacementsDefault);

      if (this.submodalidade == "588") {
        if (
          pessoa.dados_complementares.perfil &&
          investimentosFinancPessoa > 1000000
        ) {
          this.attachments.push({
            item: {
              content: termo4A,
              name: "ANEXO A À RESOLUÇÃO CVM Nº 88, DE 27 DE ABRIL DE 2022"
            },
            url: "",
            tipo: "editor",
            parseRef: "parsedContentTermoAnexo"
          });
          this.order.investor_type = "anexo_a";
        } else if (
          pessoa.dados_complementares.perfil &&
          rendaBrutaPessoa > 200000 &&
          investimentosFinancPessoa <= 2000000
        ) {
          this.attachments.push({
            item: {
              content: termo4B,
              name: "ANEXO B À RESOLUÇÃO CVM Nº 88, DE 27 DE ABRIL DE 2022"
            },
            url: "",
            tipo: "editor",
            parseRef: "parsedContentTermoAnexo"
          });
          this.order.investor_type = "anexo_b";
        } else if (
          pessoa.dados_complementares.perfil &&
          rendaBrutaPessoa <= 200000 &&
          investimentosFinancPessoa <= 2000000
        ) {
          this.attachments.push({
            item: {
              content: termo4C,
              name: "ANEXO C À RESOLUÇÃO CVM Nº 88, DE 27 DE ABRIL DE 2022"
            },
            url: "",
            tipo: "editor",
            parseRef: "parsedContentTermoAnexo"
          });
          this.order.investor_type = "anexo_c";
        }
      }
    },
    async makeObjetoContratoCCB(pessoa, custom_object = undefined) {
      moment.locale("pt_br");
      const publicSettings = await settingsService.getPublicSettings();
      var dataAporteParaTrabalhar = moment();
      if (custom_object) {
        dataAporteParaTrabalhar = custom_object.data;
      }

      const that = this;
      const valorAporte =
        that.order.item.order.totalValue -
        that.disclaimerValueTaxaAdministrativa;

      let dataAporteDia = dataAporteParaTrabalhar.format("DD");
      let dataAporteMes = dataAporteParaTrabalhar.format("MMMM");
      let dataAporteAno = dataAporteParaTrabalhar.format("YYYY");
      let dataAporte =
        dataAporteDia +
        " de " +
        dataAporteMes.charAt(0).toUpperCase() +
        dataAporteMes.substring(1) +
        " de " +
        dataAporteAno;

      var investidorEndereco =
        that.order.user.endereco.rua + ", " + that.order.user.endereco.numero;
      if (
        that.order.user.endereco.complemento &&
        that.order.user.endereco.complemento != ""
      ) {
        investidorEndereco =
          investidorEndereco + ", " + that.order.user.endereco.complemento;
      }
      investidorEndereco =
        investidorEndereco + " - " + that.order.user.endereco.bairro;

      /**
       * Campos dinâmicos
       */
      var ofertaTaxaJuros = "";
      if (that.order.item.fields && that.order.item.fields["taxa_juros"]) {
        ofertaTaxaJuros = that.order.item.fields["taxa_juros"].value;
      }
      var ofertaJurosMora = "";
      if (that.order.item.fields && that.order.item.fields["juros_mora"]) {
        ofertaJurosMora = that.order.item.fields["juros_mora"].value;
      }
      var ofertaMultaPorInadimplento = "";
      if (
        that.order.item.fields &&
        that.order.item.fields["multa_por_inadimplento"]
      ) {
        ofertaMultaPorInadimplento =
          that.order.item.fields["multa_por_inadimplento"].value;
      }
      var ofertaPrimeiroVencimento = "";
      if (
        that.order.item.fields &&
        that.order.item.fields["primeiro_vencimento"]
      ) {
        ofertaPrimeiroVencimento =
          that.order.item.fields["primeiro_vencimento"].value;
      }
      var ofertaTipoRegimeEmitente = "PRÉ-FIXADO";
      if (
        that.order.item.fields &&
        that.order.item.fields["tipo_regime_emitente"]
      ) {
        ofertaTipoRegimeEmitente =
          that.order.item.fields["tipo_regime_emitente"].value;
      }
      var ofertaDataEncerramento = "";
      if (
        that.order.item.fields &&
        that.order.item.fields["Encerramento da Oferta"]
      ) {
        ofertaDataEncerramento =
          that.order.item.fields["Encerramento da Oferta"].value;
      }
      var ofertaNumeroRI = "";
      if (that.order.item.fields && that.order.item.fields["numero_ri"]) {
        ofertaNumeroRI = that.order.item.fields["numero_ri"].value;
      }
      var ofertaNumeroMatricula = "";
      if (
        that.order.item.fields &&
        that.order.item.fields["numero_matricula"]
      ) {
        ofertaNumeroMatricula =
          that.order.item.fields["numero_matricula"].value;
      }
      var ofertaNumeroCartorio = "";
      if (that.order.item.fields && that.order.item.fields["numero_cartorio"]) {
        ofertaNumeroCartorio = that.order.item.fields["numero_cartorio"].value;
      }
      var ofertaNumeroGarantia = "";
      if (that.order.item.fields && that.order.item.fields["garantia"]) {
        ofertaNumeroGarantia = that.order.item.fields["garantia"].value;
      }
      /**
       * Empresa
       */
      var ofertaEmpresaRua = "";
      if (
        that.order.item.dados_complementares &&
        that.order.item.dados_complementares.empresa &&
        that.order.item.dados_complementares.empresa.endereco
      ) {
        ofertaEmpresaRua =
          that.order.item.dados_complementares.empresa.endereco.rua +
          ", " +
          that.order.item.dados_complementares.empresa.endereco.numero;
        if (
          that.order.item.dados_complementares.empresa.endereco.complemento &&
          that.order.item.dados_complementares.empresa.endereco.complemento !=
            ""
        ) {
          ofertaEmpresaRua =
            ofertaEmpresaRua +
            ", " +
            that.order.item.dados_complementares.empresa.endereco.complemento;
        }
        ofertaEmpresaRua =
          ofertaEmpresaRua +
          " - " +
          that.order.item.dados_complementares.empresa.endereco.bairro;
      }
      var ofertaEmpresaCEP = "";
      if (
        that.order.item.dados_complementares &&
        that.order.item.dados_complementares.empresa &&
        that.order.item.dados_complementares.empresa.endereco
      ) {
        ofertaEmpresaCEP =
          that.order.item.dados_complementares.empresa.endereco.cep;
      }
      var ofertaEmpresaCidade = "";
      if (
        that.order.item.dados_complementares &&
        that.order.item.dados_complementares.empresa &&
        that.order.item.dados_complementares.empresa.endereco
      ) {
        ofertaEmpresaCidade =
          that.order.item.dados_complementares.empresa.endereco.cidade;
      }
      var ofertaEmpresaUF = "";
      if (
        that.order.item.dados_complementares &&
        that.order.item.dados_complementares.empresa &&
        that.order.item.dados_complementares.empresa.endereco
      ) {
        ofertaEmpresaUF =
          that.order.item.dados_complementares.empresa.endereco.estado;
      }
      var ofertaEmpresaRazaoSocial = "";
      if (
        that.order.item.dados_complementares &&
        that.order.item.dados_complementares.empresa
      ) {
        ofertaEmpresaRazaoSocial =
          that.order.item.dados_complementares.empresa.nome;
      }
      var ofertaEmpresaCNPJ = "";
      if (
        that.order.item.dados_complementares &&
        that.order.item.dados_complementares.empresa &&
        that.order.item.dados_complementares.empresa.documento
      ) {
        ofertaEmpresaCNPJ =
          that.order.item.dados_complementares.empresa.documento.numero;
      }
      var ofertaEmpresaEmail = "";
      if (
        that.order.item.dados_complementares &&
        that.order.item.dados_complementares.empresa &&
        that.order.item.dados_complementares.empresa.email
      ) {
        ofertaEmpresaEmail =
          that.order.item.dados_complementares.empresa.email.email;
      }

      /**
       * Oferta
       */
      var ofertaCidade = "";
      if (that.order.item.cidade) {
        ofertaCidade = that.order.item.cidade;
      }
      var ofertaUF = "";
      if (that.order.item.estado) {
        ofertaUF = that.order.item.estado.uf;
      }

      /**
       * ECWL_APORTE
       */
      if (custom_object) {
        that.objetoContratoCCB.ecwl_aporte.investidor_ip = custom_object.ip;
      } else {
        try {
          await fetch("https://api.ipify.org?format=json")
            .then(x => x.json())
            .then(({ ip }) => {
              that.objetoContratoCCB.ecwl_aporte.investidor_ip = ip;
            });
        } catch (e) {
          that.hasError = true;
          that.$toasted.show(
            "Ocorreu um erro na simulação. Por favor, entre em contato com a plataforma.",
            {
              icon: "times",
              className: "error"
            }
          );
        }
      }
      // Forçando irregular para usar novo modelo de contrato, isso é uma medida de contorno até usar a configuraçao de
      // de contrato junto aos parametros do cliente
      let contrato_custoreal =
        (process.env.VUE_APP_ENVIRONMENT || "") === "custoreal-prd";
      that.objetoContratoCCB.parcela_irregular =
        that.order.ccb.simulacao.irregular || contrato_custoreal;
      //

      that.objetoContratoCCB.ecwl_aporte.valor_extenso = extenso(
        String(valorAporte).replace(".", ","),
        { mode: "currency", currency: { type: "BRL" } }
      ).toUpperCase();
      that.objetoContratoCCB.ecwl_aporte.numero_ccb =
        that.order.ccb.simulacao.numero_ccb;
      that.objetoContratoCCB.ecwl_aporte.valor = valorAporte;
      that.objetoContratoCCB.ecwl_aporte.data = dataAporteParaTrabalhar.format(
        "DD/MM/Y"
      );
      that.objetoContratoCCB.ecwl_aporte.data_extenso = dataAporte;
      that.objetoContratoCCB.ecwl_aporte.hora = dataAporteParaTrabalhar.format(
        "H:mm"
      );
      that.objetoContratoCCB.ecwl_aporte.investidor_nome = that.order.user.nome.toUpperCase();
      that.objetoContratoCCB.ecwl_aporte.investidor_email =
        that.order.user.email.email;
      that.objetoContratoCCB.ecwl_aporte.investidor_cpf =
        that.order.user.documento.numero;
      that.objetoContratoCCB.ecwl_aporte.investidor_endereco = investidorEndereco.toUpperCase();
      that.objetoContratoCCB.ecwl_aporte.investidor_endereco_cidade = that.order.user.endereco.cidade.toUpperCase();
      that.objetoContratoCCB.ecwl_aporte.investidor_endereco_cep =
        that.order.user.endereco.cep;
      that.objetoContratoCCB.ecwl_aporte.investidor_endereco_uf = that.order.user.endereco.estado.uf.toUpperCase();
      that.objetoContratoCCB.ecwl_aporte.hash_assinatura = fiduciaService.generateHashAssinatura();
      that.objetoContratoCCB.ecwl_aporte.investidor_endereco_completo =
        investidorEndereco.toUpperCase() +
        ", " +
        that.order.user.endereco.cidade.toUpperCase() +
        "/" +
        that.order.user.endereco.estado.uf.toUpperCase() +
        ", " +
        that.order.user.endereco.cep;

      /**
       * SIMULACAO
       */
      that.objetoContratoCCB.simulacao.valor_liquido_calculado =
        that.order.ccb.simulacao.response.ValorLiquido;
      that.objetoContratoCCB.simulacao.valor_liberado_nf =
        that.order.ccb.simulacao.response.valor_liberado_NF; // - that.disclaimerValueTaxaAdministrativa;
      that.objetoContratoCCB.simulacao.parcela_NF =
        that.order.ccb.simulacao.response.parcela_NF;
      that.objetoContratoCCB.simulacao.taxa_juros_anual =
        that.order.ccb.simulacao.response.taxa_juros_anual.toString() + "%";
      that.objetoContratoCCB.simulacao.cet_nf =
        that.order.ccb.simulacao.response.CET_NF;
      that.objetoContratoCCB.simulacao.cet_nf_mensal =
        that.order.ccb.simulacao.response.CET_NF_MENSAL;
      that.objetoContratoCCB.simulacao.iof_nf =
        that.order.ccb.simulacao.response.IOF_NF;
      that.objetoContratoCCB.simulacao.ValorDaCAD =
        that.order.ccb.simulacao.response.ValorDaCAD;
      that.objetoContratoCCB.simulacao.parcelas.numero_parcelas =
        that.order.ccb.simulacao.payload.parcelas + " Parcela(s)";
      that.objetoContratoCCB.simulacao.parcelas.valor_parcela = 0;
      that.objetoContratoCCB.simulacao.parcelas.data_final_vencimento = ofertaPrimeiroVencimento;
      that.objetoContratoCCB.simulacao.parcelas.lista = [];

      var dataPagamentoMoment = moment(ofertaPrimeiroVencimento);
      let totalParcelas = 0;
      await that.order.ccb.simulacao.response.NF_table.map(async nf_parcela => {
        if (nf_parcela.numeroPrestacao > 1) {
          if (nf_parcela.dataVencimento) {
            dataPagamentoMoment = moment(nf_parcela.dataVencimento);
          } else {
            dataPagamentoMoment = moment(ofertaDataEncerramento).add(
              nf_parcela.diasCorridos,
              "days"
            );
          }
        }
        let parcela = {
          numero_prestacao: nf_parcela.numeroPrestacao,
          data_pagamento: dataPagamentoMoment.format("DD/MM/YYYY"),
          saldo_devedor: nf_parcela.amortizacao,
          juros: nf_parcela.juros,
          valor_parcelas: nf_parcela.valorParcelas
        };
        that.objetoContratoCCB.simulacao.parcelas.lista.push(parcela);
        that.objetoContratoCCB.simulacao.parcelas.data_final_vencimento = dataPagamentoMoment.format(
          "DD/MM/YYYY"
        );
        that.objetoContratoCCB.simulacao.parcelas.juros = nf_parcela.juros;
        totalParcelas += parseFloat(nf_parcela.valorParcelas) || 0;
      });
      that.objetoContratoCCB.simulacao.parcelas.totalParcelas = totalParcelas;

      /**
       * ECWL_OFERTA
       */
      that.objetoContratoCCB.ecwl_oferta.taxa_juros = ofertaTaxaJuros + " %";
      that.objetoContratoCCB.ecwl_oferta.juros_mora = ofertaJurosMora + " %";
      that.objetoContratoCCB.ecwl_oferta.multa_por_inadimplento =
        ofertaMultaPorInadimplento + " %";
      that.objetoContratoCCB.ecwl_oferta.tipo_regime_emitente = ofertaTipoRegimeEmitente;
      that.objetoContratoCCB.ecwl_oferta.primeiro_vencimento = moment(
        ofertaPrimeiroVencimento
      ).format("DD/MM/YY");
      that.objetoContratoCCB.ecwl_oferta.empresa_rua = ofertaEmpresaRua.toUpperCase();
      that.objetoContratoCCB.ecwl_oferta.empresa_cep = ofertaEmpresaCEP;
      that.objetoContratoCCB.ecwl_oferta.empresa_cidade = ofertaEmpresaCidade.toUpperCase();
      that.objetoContratoCCB.ecwl_oferta.empresa_uf = ofertaEmpresaUF.toUpperCase();
      that.objetoContratoCCB.ecwl_oferta.cidade = ofertaCidade.toUpperCase();
      that.objetoContratoCCB.ecwl_oferta.uf = ofertaUF.toUpperCase();
      that.objetoContratoCCB.ecwl_oferta.empresa_razao_social = ofertaEmpresaRazaoSocial.toUpperCase();
      that.objetoContratoCCB.ecwl_oferta.empresa_cnpj = ofertaEmpresaCNPJ;
      that.objetoContratoCCB.ecwl_oferta.empresa_email = ofertaEmpresaEmail;
      that.objetoContratoCCB.ecwl_oferta.data_encerramento = moment(
        ofertaDataEncerramento
      ).format("DD/MM/YYYY");
      that.objetoContratoCCB.ecwl_oferta.ofertaNumeroRI = ofertaNumeroRI;
      that.objetoContratoCCB.ecwl_oferta.ofertaNumeroMatricula = ofertaNumeroMatricula;
      that.objetoContratoCCB.ecwl_oferta.ofertaNumeroCartorio = ofertaNumeroCartorio;
      that.objetoContratoCCB.ecwl_oferta.ofertaNumeroGarantia = ofertaNumeroGarantia;
      that.objetoContratoCCB.ecwl_oferta.numero_banco =
        that.order.item.dados_bancarios.banco.code;
      that.objetoContratoCCB.ecwl_oferta.agencia =
        that.order.item.dados_bancarios.agencia_numero;
      that.objetoContratoCCB.ecwl_oferta.conta =
        that.order.item.dados_bancarios.conta_numero;
      that.objetoContratoCCB.ecwl_oferta.digito_conta =
        that.order.item.dados_bancarios.conta_digito;
      that.objetoContratoCCB.ecwl_oferta.empresa_ie = this.financing.dados_complementares.empresa.dados_complementares.inscricao_estadual;
      that.objetoContratoCCB.ecwl_oferta.empresa_data_constituicao = this.financing.dados_complementares.empresa.dados_complementares.data_constituicao;

      that.objetoContratoCCB.ecwl_oferta.valor_tarifa = this.getValorTarifa();

      /**
       * Início - Criar estes campos em algum lugar
       */

      /**
       * CREDOR
       */
      that.objetoContratoCCB.credor.razao_social = this.financing.bancarizador.razao_social;
      that.objetoContratoCCB.credor.cnpj = this.financing.bancarizador.cnpj;
      that.objetoContratoCCB.credor.endereco = this.financing.bancarizador.endereco;
      that.objetoContratoCCB.credor.cep = this.financing.bancarizador.cep;
      that.objetoContratoCCB.credor.cidade = this.financing.bancarizador.cidade;
      that.objetoContratoCCB.credor.uf = this.financing.bancarizador.uf;
      that.objetoContratoCCB.credor.natureza = this.financing.bancarizador.natureza;
      that.objetoContratoCCB.credor.praca_pagamento = this.financing.bancarizador.praca_pagamento;
      that.objetoContratoCCB.credor.email = this.financing.bancarizador.email;
      that.objetoContratoCCB.credor.logotipo_url = this.financing.bancarizador.logotipoURL;

      /**
       * AVALISTAS
       */
      that.objetoContratoCCB.ecwl_oferta.avalistaPrincipal = {
        nome: "",
        id: "",
        endereco: {
          cep: "",
          estado: "",
          cidade: "",
          bairro: ""
        },
        dados_complementares: {
          responsavel: {
            nome: "",
            documento: {
              numero: ""
            }
          }
        }
      };
      if (that.order.item.avalistaPrincipal) {
        const avalistaPrincipal = await pessoasService.getPessoa(
          that.order.item.avalistaPrincipal.id
        );
        that.objetoContratoCCB.ecwl_oferta.avalistaPrincipal = avalistaPrincipal.data();
      }

      that.objetoContratoCCB.ecwl_oferta.demaisAvalistas = [];
      if (that.order.item.demaisAvalistas) {
        await that.order.item.demaisAvalistas.map(async avalista => {
          const avalistaData = await pessoasService.getPessoa(avalista.id);
          that.objetoContratoCCB.ecwl_oferta.demaisAvalistas.push(
            avalistaData.data()
          );
        });
      }

      /**
       * CONTRATO
       */
      var contratoCCB = "";
      var contratoCCBEndosso = "";
      var contratoCCBEndossoComplemento = "";
      if (publicSettings.terms) {
        var contratoCCBFromSettings = "";
        var contratoCCBEndossoFromSettings = "";
        var contratoCCBEndossoComplementoFromSettings = "";
        if (publicSettings.terms.contrato_ccb) {
          contratoCCBFromSettings = publicSettings.terms.contrato_ccb;
        }
        if (publicSettings.terms.contrato_ccb_endosso) {
          contratoCCBEndossoFromSettings =
            publicSettings.terms.contrato_ccb_endosso;
        }
        if (publicSettings.terms.contrato_ccb_endosso_complemento) {
          contratoCCBEndossoComplementoFromSettings =
            publicSettings.terms.contrato_ccb_endosso_complemento;
        }

        var outrasPlataformas = toNumberSafe(
          pessoa.dados_complementares?.perfil?.investimentos_outras_plataformas
        );
        var nestaPlataforma = toNumberSafe(
          pessoa.dados_complementares?.perfil?.investimentos_nesta_plataforma
        );

        const montantePreFormatado = parseFloat(
          outrasPlataformas + nestaPlataforma
        )
          .toFixed(2)
          .replace(".", ",");
        const montante =
          "R$ " +
          montantePreFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        contratoCCB = contratoCCBFromSettings
          .replace("#data", that.objetoContratoCCB.ecwl_aporte.data)
          .replace("#dt_atual", this.dataAtual)
          .replace(
            "#oferta_encerramento",
            that.objetoContratoCCB.ecwl_oferta.data_encerramento
          )
          .replace(
            "#local",
            that.objetoContratoCCB.ecwl_aporte.investidor_endereco_cidade
          )
          .replace(
            "#nomeInvestidor",
            that.objetoContratoCCB.ecwl_aporte.investidor_nome
          )
          .replace(
            "#cpfInvestidor",
            that.objetoContratoCCB.ecwl_aporte.investidor_cpf
          )
          .replace(
            "#razaoSocialEmissor",
            that.objetoContratoCCB.ecwl_oferta.empresa_razao_social
          )
          .replace("#montante", montante)
          .replace(
            "#bancarizadorRazaoSocial",
            that.objetoContratoCCB.credor.razao_social
          )
          .replace("#bancarizadorCidade", that.objetoContratoCCB.credor.cidade)
          .replace("#bancarizadorCidade", that.objetoContratoCCB.credor.cidade)
          .replace("#bancarizadorCNPJ", that.objetoContratoCCB.credor.cnpj)
          .replace(
            "#investidor_endereco_completo",
            that.objetoContratoCCB.ecwl_aporte.investidor_endereco_completo
          )
          .replace(
            "#oferta_numero_ri",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroRI
          )
          .replace(
            "#oferta_numero_matricula",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroMatricula
          )
          .replace(
            "#oferta_numero_cartorio",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroCartorio
          )
          .replace("#oferta_cidade", that.objetoContratoCCB.ecwl_oferta.cidade)
          .replace("#oferta_estado", that.objetoContratoCCB.ecwl_oferta.uf)
          .replace(
            "#oferta_cnpj_empresa",
            that.objetoContratoCCB.ecwl_oferta.empresa_cnpj
          )
          .replace(
            "#oferta_quantidade_parcelas",
            that.objetoContratoCCB.simulacao.parcelas.numero_parcelas
          )
          .replace(
            "#oferta_primeiro_vencimento",
            that.objetoContratoCCB.simulacao.parcelas.data_final_vencimento
          )
          .replace(
            "#api_valor_da_parcela",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.parcelas.juros)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#oferta_taxa_juros_mensal",
            that.objetoContratoCCB.ecwl_oferta.taxa_juros
          )
          .replace(
            "#oferta_numero_banco",
            that.objetoContratoCCB.ecwl_oferta.numero_banco
          )
          .replace(
            "#oferta_agencia",
            that.objetoContratoCCB.ecwl_oferta.agencia
          )
          .replace("#oferta_conta", that.objetoContratoCCB.ecwl_oferta.conta)
          .replace(
            "#oferta_digito_conta",
            that.objetoContratoCCB.ecwl_oferta.digito_conta
          )
          .replace(
            "#aporte_valor_bruto",
            "R$ " +
              parseFloat(valorAporte)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#aporte_taxa_juros_anual",
            that.objetoContratoCCB.simulacao.taxa_juros_anual
          )
          .replace(
            "#api_iof",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.iof_nf)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_cet_am",
            that.objetoContratoCCB.simulacao.cet_nf_mensal
              ? that.objetoContratoCCB.simulacao.cet_nf_mensal.toString() + "%"
              : ""
          )
          .replace(
            "#api_cet_aa",
            that.objetoContratoCCB.simulacao.cet_nf
              ? that.objetoContratoCCB.simulacao.cet_nf.toString() + "%"
              : ""
          )
          .replace(
            "#api_valor_bruto",
            "R$ " +
              parseFloat(that.objetoContratoCCB.ecwl_aporte.valor)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_valor_liquido",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.valor_liberado_nf)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_fiducia_parcela_nf",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.parcela_NF)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_tac",
            "R$ " +
              parseFloat(
                that.objetoContratoCCB.simulacao.ValorDaCAD
                  ? that.objetoContratoCCB.simulacao.ValorDaCAD
                  : 0
              )
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_numero_ccb",
            that.objetoContratoCCB.ecwl_aporte.numero_ccb
          );

        // that.objetoContratoCCB.simulacao.valor_liberado_nf = that.order.ccb.simulacao.response.valor_liberado_NF - that.disclaimerValueTaxaAdministrativa;
        that.objetoContratoCCB.simulacao.taxa_juros_anual =
          that.order.ccb.simulacao.response.taxa_juros_anual.toString() + "%";
        that.objetoContratoCCB.simulacao.cet_nf =
          that.order.ccb.simulacao.response.CET_NF;

        contratoCCBEndosso = contratoCCBEndossoFromSettings
          .replace("#data", that.objetoContratoCCB.ecwl_aporte.data)
          .replace("#dt_atual", this.dataAtual)
          .replace(
            "#oferta_encerramento",
            that.objetoContratoCCB.ecwl_oferta.data_encerramento
          )
          .replace(
            "#local",
            that.objetoContratoCCB.ecwl_aporte.investidor_endereco_cidade
          )
          .replace(
            "#nomeInvestidor",
            that.objetoContratoCCB.ecwl_aporte.investidor_nome
          )
          .replace(
            "#cpfInvestidor",
            that.objetoContratoCCB.ecwl_aporte.investidor_cpf
          )
          .replace(
            "#razaoSocialEmissor",
            that.objetoContratoCCB.ecwl_oferta.empresa_razao_social
          )
          .replace("#montante", montante)
          .replace(
            "#bancarizadorRazaoSocial",
            that.objetoContratoCCB.credor.razao_social
          )
          .replace("#bancarizadorCidade", that.objetoContratoCCB.credor.cidade)
          .replace("#bancarizadorCidade", that.objetoContratoCCB.credor.cidade)
          .replace("#bancarizadorCNPJ", that.objetoContratoCCB.credor.cnpj)
          .replace(
            "#investidor_endereco_completo",
            that.objetoContratoCCB.ecwl_aporte.investidor_endereco_completo
          )
          .replace(
            "#oferta_numero_ri",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroRI
          )
          .replace(
            "#oferta_numero_matricula",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroMatricula
          )
          .replace(
            "#oferta_numero_cartorio",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroCartorio
          )
          .replace("#oferta_cidade", that.objetoContratoCCB.ecwl_oferta.cidade)
          .replace("#oferta_estado", that.objetoContratoCCB.ecwl_oferta.uf)
          .replace(
            "#oferta_cnpj_empresa",
            that.objetoContratoCCB.ecwl_oferta.empresa_cnpj
          )
          .replace(
            "#oferta_quantidade_parcelas",
            that.objetoContratoCCB.simulacao.parcelas.numero_parcelas
          )
          .replace(
            "#oferta_primeiro_vencimento",
            that.objetoContratoCCB.simulacao.parcelas.data_final_vencimento
          )
          .replace(
            "#api_valor_da_parcela",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.parcelas.juros)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#oferta_taxa_juros_mensal",
            that.objetoContratoCCB.ecwl_oferta.taxa_juros
          )
          .replace(
            "#oferta_numero_banco",
            that.objetoContratoCCB.ecwl_oferta.numero_banco
          )
          .replace(
            "#oferta_agencia",
            that.objetoContratoCCB.ecwl_oferta.agencia
          )
          .replace("#oferta_conta", that.objetoContratoCCB.ecwl_oferta.conta)
          .replace(
            "#oferta_digito_conta",
            that.objetoContratoCCB.ecwl_oferta.digito_conta
          )
          .replace(
            "#aporte_valor_bruto",
            "R$ " +
              parseFloat(valorAporte)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#aporte_taxa_juros_anual",
            that.objetoContratoCCB.simulacao.taxa_juros_anual
          )
          .replace(
            "#api_iof",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.iof_nf)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_cet_am",
            that.objetoContratoCCB.simulacao.cet_nf_mensal
              ? that.objetoContratoCCB.simulacao.cet_nf_mensal.toString() + "%"
              : ""
          )
          .replace(
            "#api_cet_aa",
            that.objetoContratoCCB.simulacao.cet_nf
              ? that.objetoContratoCCB.simulacao.cet_nf.toString() + "%"
              : ""
          )
          .replace(
            "#api_valor_bruto",
            "R$ " +
              parseFloat(that.objetoContratoCCB.ecwl_aporte.valor)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_valor_liquido",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.valor_liberado_nf)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_tac",
            "R$ " +
              parseFloat(
                that.objetoContratoCCB.simulacao.ValorDaCAD
                  ? that.objetoContratoCCB.simulacao.ValorDaCAD
                  : 0
              )
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_fiducia_parcela_nf",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.parcela_NF)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_numero_ccb",
            that.objetoContratoCCB.ecwl_aporte.numero_ccb
          );

        contratoCCBEndossoComplemento = contratoCCBEndossoComplementoFromSettings
          .replace("#data", that.objetoContratoCCB.ecwl_aporte.data)
          .replace("#dt_atual", this.dataAtual)
          .replace(
            "#oferta_encerramento",
            that.objetoContratoCCB.ecwl_oferta.data_encerramento
          )
          .replace(
            "#local",
            that.objetoContratoCCB.ecwl_aporte.investidor_endereco_cidade
          )
          .replace(
            "#nomeInvestidor",
            that.objetoContratoCCB.ecwl_aporte.investidor_nome
          )
          .replace(
            "#cpfInvestidor",
            that.objetoContratoCCB.ecwl_aporte.investidor_cpf
          )
          .replace(
            "#razaoSocialEmissor",
            that.objetoContratoCCB.ecwl_oferta.empresa_razao_social
          )
          .replace("#montante", montante)
          .replace(
            "#bancarizadorRazaoSocial",
            that.objetoContratoCCB.credor.razao_social
          )
          .replace("#bancarizadorCidade", that.objetoContratoCCB.credor.cidade)
          .replace("#bancarizadorCidade", that.objetoContratoCCB.credor.cidade)
          .replace("#bancarizadorCNPJ", that.objetoContratoCCB.credor.cnpj)
          .replace(
            "#investidor_endereco_completo",
            that.objetoContratoCCB.ecwl_aporte.investidor_endereco_completo
          )
          .replace(
            "#oferta_numero_ri",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroRI
          )
          .replace(
            "#oferta_numero_matricula",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroMatricula
          )
          .replace(
            "#oferta_numero_cartorio",
            that.objetoContratoCCB.ecwl_oferta.ofertaNumeroCartorio
          )
          .replace("#oferta_cidade", that.objetoContratoCCB.ecwl_oferta.cidade)
          .replace("#oferta_estado", that.objetoContratoCCB.ecwl_oferta.uf)
          .replace(
            "#oferta_cnpj_empresa",
            that.objetoContratoCCB.ecwl_oferta.empresa_cnpj
          )
          .replace(
            "#oferta_quantidade_parcelas",
            that.objetoContratoCCB.simulacao.parcelas.numero_parcelas
          )
          .replace(
            "#oferta_primeiro_vencimento",
            that.objetoContratoCCB.simulacao.parcelas.data_final_vencimento
          )
          .replace(
            "#api_valor_da_parcela",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.parcelas.juros)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#oferta_taxa_juros_mensal",
            that.objetoContratoCCB.ecwl_oferta.taxa_juros
          )
          .replace(
            "#oferta_numero_banco",
            that.objetoContratoCCB.ecwl_oferta.numero_banco
          )
          .replace(
            "#oferta_agencia",
            that.objetoContratoCCB.ecwl_oferta.agencia
          )
          .replace("#oferta_conta", that.objetoContratoCCB.ecwl_oferta.conta)
          .replace(
            "#oferta_digito_conta",
            that.objetoContratoCCB.ecwl_oferta.digito_conta
          )
          .replace(
            "#aporte_valor_bruto",
            "R$ " +
              parseFloat(valorAporte)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#aporte_taxa_juros_anual",
            that.objetoContratoCCB.simulacao.taxa_juros_anual
          )
          .replace(
            "#api_iof",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.iof_nf)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_cet_am",
            that.objetoContratoCCB.simulacao.cet_nf_mensal
              ? that.objetoContratoCCB.simulacao.cet_nf_mensal.toString() + "%"
              : ""
          )
          .replace(
            "#api_cet_aa",
            that.objetoContratoCCB.simulacao.cet_nf
              ? that.objetoContratoCCB.simulacao.cet_nf.toString() + "%"
              : ""
          )
          .replace(
            "#api_valor_bruto",
            "R$ " +
              parseFloat(that.objetoContratoCCB.ecwl_aporte.valor)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_valor_liquido",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.valor_liberado_nf)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_fiducia_parcela_nf",
            "R$ " +
              parseFloat(that.objetoContratoCCB.simulacao.parcela_NF)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_tac",
            "R$ " +
              parseFloat(
                that.objetoContratoCCB.simulacao.ValorDaCAD
                  ? that.objetoContratoCCB.simulacao.ValorDaCAD
                  : 0
              )
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          )
          .replace(
            "#api_numero_ccb",
            that.objetoContratoCCB.ecwl_aporte.numero_ccb
          );
      }
      that.objetoContratoCCB.contrato.contrato_ccb = contratoCCB;
      that.objetoContratoCCB.contrato.anexo_contrato_ccb_avalista = contratoCCBEndossoComplemento;
      that.objetoContratoCCB.contrato.anexo_contrato_ccb = contratoCCBEndosso;

      that.order.ccb.contrato_ccb = that.objetoContratoCCB;
    },
    getPrimeiroVencimentoSimulacao() {
      var primeiroVencimento = "";
      var primeiroVencimentoMoment = {};
      if (this.financing.fields["primeiro_vencimento"]) {
        primeiroVencimento = this.financing.fields["primeiro_vencimento"].value;
        primeiroVencimentoMoment = moment(primeiroVencimento);
      }
      var dataEncerramento = "";
      var dataEncerramentoMoment = {};
      if (this.financing.fields["Encerramento da Oferta"]) {
        dataEncerramento = this.financing.fields["Encerramento da Oferta"]
          .value;
        dataEncerramentoMoment = moment(dataEncerramento);
      }

      let diferencaPrimeiroVencimentoDataEncerramento = primeiroVencimentoMoment.diff(
        dataEncerramentoMoment,
        "days"
      );
      let primeiroVencimentoSimulacaoMoment = moment().add(
        diferencaPrimeiroVencimentoDataEncerramento,
        "days"
      );

      return primeiroVencimentoSimulacaoMoment.format("YYYY-MM-DD");
    },
    getValorAporte(formatCurrency = false) {
      const valor =
        this.order.item.order.totalValue -
        this.disclaimerValueTaxaAdministrativa;
      if (formatCurrency) {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL"
        }).format(valor);
      }

      return valor;
    },
    getValorTarifa() {
      let that = this;
      const valorAporte = this.getValorAporte();

      var ofertaTacMinimo = "";
      if (that.order.item.fields && that.order.item.fields["tac_minimo"]) {
        ofertaTacMinimo = that.order.item.fields["tac_minimo"].value;
      }
      var ofertaTacPercentual = "";
      if (that.order.item.fields && that.order.item.fields["tac_percentual"]) {
        ofertaTacPercentual = that.order.item.fields["tac_percentual"].value;
      }
      var ofertaTacFixo = "";
      if (that.order.item.fields && that.order.item.fields["tac_fixo"]) {
        ofertaTacFixo = that.order.item.fields["tac_fixo"].value;
      }

      var valorTarifa = ofertaTacMinimo;
      var preCalculo1 =
        Number(ofertaTacPercentual) / 100
          ? Number(ofertaTacPercentual) / 100
          : 0;
      var calculo1 = preCalculo1 * valorAporte;
      var calculo2 = calculo1 + ofertaTacFixo;
      if (calculo2 > valorTarifa) {
        valorTarifa = calculo2;
      }

      return valorTarifa;
    },
    getDadosBancarizadorManual() {
      var valor = this.order.item.order.totalValue;

      var valor_liberado_NF = 0;
      var taxa_juros_anual = 0; // campos dinamicos
      var CET_NF = 0; // campos dinamicos
      var IOF_NF = 0; // campos dinamicos
      var juros = 0; // campos dinamicos
      var valorParcelas = 0;

      if (
        this.order.item.fields &&
        this.order.item.fields["bancarizador_manual_taxa_juros_anual"]
      ) {
        taxa_juros_anual = this.order.item.fields[
          "bancarizador_manual_taxa_juros_anual"
        ].value;
        juros = (valor * taxa_juros_anual) / 100;

        valorParcelas = valor + juros;
      }
      if (
        this.order.item.fields &&
        this.order.item.fields["bancarizador_manual_CET_NF"]
      ) {
        CET_NF = this.order.item.fields["bancarizador_manual_CET_NF"].value;
      }
      if (
        this.order.item.fields &&
        this.order.item.fields["bancarizador_manual_IOF_NF"]
      ) {
        let iof_percent = this.order.item.fields["bancarizador_manual_IOF_NF"]
          .value;
        IOF_NF = valor * iof_percent;

        valor_liberado_NF = valor - IOF_NF;
      }
      // if ( this.order.item.fields && this.order.item.fields['bancarizador_manual_juros'] ) {
      //   juros = this.order.item.fields['bancarizador_manual_juros'].value;
      // }

      var NF_table_item = {
        numeroPrestacao: 1,
        amortizacao: valor,
        juros: juros,
        valorParcelas: valorParcelas
      };

      var NF_table = [];
      NF_table.push(NF_table_item);

      return {
        valor_liberado_NF: valor_liberado_NF,
        taxa_juros_anual: taxa_juros_anual,
        CET_NF: CET_NF,
        IOF_NF: IOF_NF,
        NF_table: NF_table
      };
    },
    contratoCCB_makePayload() {
      var dataEncerramento = "";
      if (this.financing.fields["Encerramento da Oferta"]) {
        dataEncerramento = this.financing.fields["Encerramento da Oferta"]
          .value;
      }
      let primeiroVencimentoSimulacao = this.getPrimeiroVencimentoSimulacao();
      //Fiducia estava distorcendo os calculos quando parcela estava sendo enviado como string "1"
      //e nao como number 1. Forcamos o type cast para number.
      var parcelas = !isNaN(parseInt(this.financing.fields["parcelas"].value))
        ? parseInt(this.financing.fields["parcelas"].value)
        : 0;
      //Assim como parcela taxa de juros também alterada para float.
      var taxaJuros = !isNaN(
        parseFloat(this.financing.fields["taxa_juros"].value)
      )
        ? parseFloat(this.financing.fields["taxa_juros"].value)
        : 0;

      var periodicidade = "";
      if (this.financing.fields["periodicidade"]) {
        periodicidade = this.financing.fields["periodicidade"].value;
      }
      var metodoCalculo = "1";
      // if ( this.financing.fields['modalidade_remuneracao'] ) {
      //   if ( this.financing.fields['modalidade_remuneracao'].value == "Bullet" ) {
      //     metodoCalculo = "3";
      //   }
      // }
      let valorTarifa = this.getValorTarifa();
      const objeto = {
        metodo_calculo: metodoCalculo,
        tarifa: 0,
        tipo_pessoa: "PJ",
        valor_liberado: this.order.item.order.totalValue,
        primeiro_vencimento: primeiroVencimentoSimulacao,
        parcelas: parcelas,
        taxa_juros: taxaJuros,
        periodicidade: periodicidade,
        TAC: valorTarifa,
        data_aceite: dataEncerramento
      };

      return objeto;
    },

    async getContratoCCBManual(pessoa) {
      const objeto = this.contratoCCB_makePayload();
      const dados = this.getDadosBancarizadorManual();
      const dadosToPush = {
        payload: objeto,
        response: dados
      };

      this.order.ccb = {
        simulacao: {
          numero_ccb: fiduciaService.generateCCB(),
          payload: objeto,
          response: dados
        }
      };

      await this.makeObjetoContratoCCB(pessoa);
      this.order.aceite_termos_hash = this.objetoContratoCCB.ecwl_aporte.hash_assinatura;
      this.order.investidor_ip = this.objetoContratoCCB.ecwl_aporte.investidor_ip;
      this.attachments.push({
        item: { content: dadosToPush, name: "Contrato CCB" },
        url: "",
        tipo: "contrato-ccb",
        parseRef: "parsedContentContratoOferta"
      });
    },

    async getContratoCCBFiducia(pessoa) {
      const that = this;
      const objeto = this.contratoCCB_makePayload();

      fiduciaService
        .simulate(objeto)
        .then(async function(result) {
          var dados = result.data;
          dados.NF_table.forEach(parcela => {
            parcela.amortizacao = dados.valor_nominal_NF; // saldo_devedor = Principal
            parcela.valorParcelas = parcela.valorParcelas; // valor_parcelas =  Total
          });
          const dadosToPush = {
            payload: objeto,
            response: dados
          };
          that.order.ccb = {
            simulacao: {
              numero_ccb: fiduciaService.generateCCB(),
              payload: objeto,
              response: dados
            }
          };
          await that.makeObjetoContratoCCB(pessoa);
          that.order.aceite_termos_hash =
            that.objetoContratoCCB.ecwl_aporte.hash_assinatura;
          that.order.investidor_ip =
            that.objetoContratoCCB.ecwl_aporte.investidor_ip;
          that.attachments.push({
            item: { content: dadosToPush, name: "Contrato CCB" },
            url: "",
            tipo: "contrato-ccb",
            parseRef: "parsedContentContratoOferta"
          });
          that.isLoading = false;
        })
        .catch(function(error) {
          that.hasError = true;
          console.log(error);
          that.$toasted.show(
            "Ocorreu um erro na geração do contrato. Por favor, entre em contato com a plataforma.",
            {
              icon: "times",
              className: "error"
            }
          );
        });
    },

    socinalContratoCCB_makePayload() {
      var parcelas = "";
      if (this.financing.fields["parcelas"]) {
        parcelas = this.financing.fields["parcelas"].value;
      }
      var dataEncerramento = "";
      if (this.financing.fields["Encerramento da Oferta"]) {
        dataEncerramento = this.financing.fields["Encerramento da Oferta"]
          .value;
      }
      var dataPrimeiroVencimento = "";
      if (this.financing.fields["primeiro_vencimento"]) {
        dataPrimeiroVencimento = this.financing.fields["primeiro_vencimento"]
          .value;
      }
      var taxaContratual = "0";
      if (this.financing.fields["taxa_juros"]) {
        taxaContratual = this.financing.fields["taxa_juros"].value;
      }
      var optanteSimples = false;
      if (this.financing.dados_complementares.empresa) {
        optanteSimples =
          this.financing.dados_complementares.empresa.dados_complementares
            .optante_simples == "SIM"
            ? "T"
            : "F";
      }
      let valorTarifa = this.getValorTarifa();
      const payload = {
        ValorLiquido: this.order.item.order.totalValue,
        DataDeVencimento: dataPrimeiroVencimento,
        NumeroDeParcelas: parcelas,
        parcelas: parcelas,
        DataDeLiberacao: dataEncerramento,
        OptanteSimples: optanteSimples,
        TaxaContratual: taxaContratual,
        ValorDaCAD: valorTarifa
      };

      return payload;
    },

    async getContratoCCBSocinal(pessoa) {
      const that = this;
      var objeto = this.socinalContratoCCB_makePayload();
      objeto.ValorDaCAD = 0;
      objeto.ValorBruto =
        that.order.item.order.totalValue -
        that.disclaimerValueTaxaAdministrativa;
      objeto.ValorLiquido =
        that.order.item.order.totalValue -
        that.disclaimerValueTaxaAdministrativa;
      objeto.taxa_safe2pay = that.disclaimerValueTaxaAdministrativa;
      var valorBruto = objeto.ValorLiquido;
      //Por determinação de SOCINAL em 17-Abr-24 informa que o agente de credito para simular e realizar contrato de credito,
      //o agente de credito deve ser o codido do investidor, e não o do tomador, o que defino o Tomador em questão é a linha de cretido
      objeto.AgenteCreditoInvestidor = pessoa.socinal?.pessoa_id ?? "";
      // INICIO DE TESTES PARCELAS SIMPLES  //
      if (
        this.financing.fields["modalidade_remuneracao"] &&
        this.financing.fields["modalidade_remuneracao"].value ===
          "Juros Simples"
      ) {
        //Customizações parcela irregular
        //Usado no parametro "conta" na integração com Socinal
        objeto.modalidade_remuneracao = this.financing.fields[
          "modalidade_remuneracao"
        ].value;

        if (this.financing.dados_complementares.empresa.socinal.pessoa_id) {
          objeto.ContaSocinal = this.financing.dados_complementares.empresa.socinal.pessoa_id;
        }
        //CPF/CNPJ
        if (this.financing.dados_complementares.empresa.documento.numero) {
          objeto.cpfCNPJ = this.financing.dados_complementares.empresa.documento.numero;
        }

        socinalService.simulate_irregular(objeto).then(async function(result) {
          var dados = result.simulacao;

          objeto.ValorDaCAD = parseFloat(that.getValorTarifa().toFixed(2));

          dados.ValorDaCAD = objeto.ValorDaCAD;

          //Valor Liquido do contrato
          var valorLiquidoCalculado =
            objeto.ValorLiquido - dados.IOF_NF - objeto.ValorDaCAD;

          dados.ValorLiquido = parseFloat(valorLiquidoCalculado.toFixed(2));

          const dadosToPush = {
            payload: objeto,
            response: dados
          };
          that.order.ccb = {
            simulacao: {
              numero_ccb: fiduciaService.generateCCB(),
              payload: objeto,
              response: dados,
              irregular: true
            }
          };

          await that.makeObjetoContratoCCB(pessoa);
          that.order.aceite_termos_hash =
            that.objetoContratoCCB.ecwl_aporte.hash_assinatura;
          that.order.investidor_ip =
            that.objetoContratoCCB.ecwl_aporte.investidor_ip;
          that.attachments.push({
            item: { content: dadosToPush, name: "Contrato CCB" },
            url: "",
            tipo: "contrato-ccb",
            parseRef: "parsedContentContratoOferta"
          });
        });
      } else {
        socinalService
          .simulate(objeto)
          .then(async function(result) {
            const dadosTemp = result.simulacao;

            objeto.ValorDaCAD = parseFloat(that.getValorTarifa().toFixed(2));

            var valorLiquidoCalculado =
              (objeto.ValorLiquido / dadosTemp.valor_liberado_NF) *
                objeto.ValorLiquido -
              objeto.ValorDaCAD;
            objeto.ValorLiquido = parseFloat(valorLiquidoCalculado.toFixed(2));
            socinalService
              .simulate(objeto)
              .then(async function(result) {
                var dados = result.simulacao;
                dados.ValorDaCAD = objeto.ValorDaCAD;
                dados.valor_liberado_NF = valorLiquidoCalculado;
                dados.NF_table.forEach(parcela => {
                  parcela.amortizacao = valorBruto;
                  parcela.juros = dados.taxa_juros_anual;
                  parcela.valorParcelas = valorBruto + dados.taxa_juros_anual;
                });

                var taxa_mensal = "";
                if (that.financing.fields["taxa_juros"]) {
                  taxa_mensal = that.financing.fields["taxa_juros"].value;
                }

                taxa_mensal = parseFloat(taxa_mensal) / 100;
                let num_meses = 12;
                let base = 100.0;
                var total = base;
                var juros = 0.0;
                for (let i = 0; i < num_meses; i++) {
                  juros = total * taxa_mensal;
                  total = total + juros;
                }
                total = total - base;
                dados.taxa_juros_anual = parseFloat(total).toFixed(2);

                const dadosToPush = {
                  payload: objeto,
                  response: dados
                };
                that.order.ccb = {
                  simulacao: {
                    numero_ccb: fiduciaService.generateCCB(),
                    payload: objeto,
                    response: dados
                  }
                };
                await that.makeObjetoContratoCCB(pessoa);
                that.order.aceite_termos_hash =
                  that.objetoContratoCCB.ecwl_aporte.hash_assinatura;
                that.order.investidor_ip =
                  that.objetoContratoCCB.ecwl_aporte.investidor_ip;
                that.attachments.push({
                  item: { content: dadosToPush, name: "Contrato CCB" },
                  url: "",
                  tipo: "contrato-ccb",
                  parseRef: "parsedContentContratoOferta"
                });
              })
              .catch(function(error) {
                that.hasError = true;
                console.log(error);
                that.$toasted.show(
                  "Ocorreu um erro na geração do contrato. Por favor, entre em contato com a plataforma.",
                  {
                    icon: "times",
                    className: "error"
                  }
                );
              });
          })
          .catch(function(error) {
            that.hasError = true;
            console.log(error);
            that.$toasted.show(
              "Ocorreu um erro na geração do contrato. Por favor, entre em contato com a plataforma.",
              {
                icon: "times",
                className: "error"
              }
            );
          });
      }
    },

    async getContratoOferta(pessoa) {
      /**
       * Contratos
       */
      const publicSettings = await settingsService.getPublicSettings();

      const razaoSocial = this.financing.dados_complementares.empresa.nome;

      var outrasPlataformas = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_outras_plataformas
      );
      var nestaPlataforma = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_nesta_plataforma
      );

      const montantePreFormatado = parseFloat(
        outrasPlataformas + nestaPlataforma
      )
        .toFixed(2)
        .replace(".", ",");
      const montante =
        "R$ " +
        montantePreFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      if (publicSettings.terms) {
        var contratoOfertaToReplace = "";
        if (this.financing.possui_contrato_personalizado) {
          contratoOfertaToReplace = this.financing.contrato_personalizado;
        } else if (publicSettings.terms.contrato_padrao) {
          contratoOfertaToReplace = publicSettings.terms.contrato_padrao;
        }

        var lnumero_ri = "";
        if (this.financing.fields["numero_ri"]) {
          lnumero_ri = this.financing.fields["numero_ri"].value;
        }
        var lnumero_matricula = "";
        if (this.financing.fields["numero_matricula"]) {
          lnumero_matricula = this.financing.fields["numero_matricula"].value;
        }
        var lnumero_cartorio = "";
        if (this.financing.fields["numero_cartorio"]) {
          lnumero_cartorio = this.financing.fields["numero_cartorio"].value;
        }
        var loferta_encerramento = "";
        if (this.financing.fields["Encerramento da Oferta"]) {
          loferta_encerramento = moment(
            this.financing.fields["Encerramento da Oferta"].value
          ).format("DD/MM/YYYY");
        }
        const replacementsContratoOferta = {
          "#dt_atual": this.dataAtual,
          "#local": pessoa.endereco.cidade,
          "#nomeInvestidor": pessoa.nome,
          "#cpfInvestidor": pessoa.documento.numero,
          "#valor_aporte": this.getValorAporte(true),
          "#data_assinatura_contrato": this.dataAtual,
          "#razaoSocialEmissor": razaoSocial,
          "#oferta_numero_ri": lnumero_ri,
          "#oferta_numero_matricula": lnumero_matricula,
          "#oferta_numero_cartorio": lnumero_cartorio,
          "#oferta_cidade": this.getCidadefinancing(this.financing),
          "#oferta_estado": this.getUFfinancing(this.financing),
          "#oferta_numero_banco": this.financing.dados_bancarios.banco.code,
          "#oferta_agencia": this.financing.dados_bancarios.agencia_numero,
          "#oferta_conta": this.financing.dados_bancarios.conta_numero,
          "#oferta_digito_conta": this.financing.dados_bancarios.conta_digito,
          "#oferta_cnpj_empresa": this.financing.dados_complementares.empresa
            .documento.numero,
          "#oferta_encerramento": loferta_encerramento,
          "#montante": montante
        };
        const contratoOferta = replaceKeywords(
          contratoOfertaToReplace,
          replacementsContratoOferta
        );

        /**
         * A submodalidade Bacen CCB não possui contrato da oferta. O contrato é por aporte.
         * Com isso, adicionei essa condição abaixo para que funcione apenas em Bacen por enquanto.
         */
        if (this.submodalidade == "bacen") {
          if (
            this.financing.bancarizador &&
            this.financing.bancarizador.integracao_id ==
              BancarizadorIntegracaoID.Manual
          ) {
            await this.getContratoCCBManual(pessoa);
          } else {
            if (
              this.financing.bancarizador &&
              this.financing.bancarizador.integracao_id ==
                BancarizadorIntegracaoID.Fiducia
            ) {
              await this.getContratoCCBFiducia(pessoa);
            } else if (
              this.financing.bancarizador &&
              this.financing.bancarizador.integracao_id ==
                BancarizadorIntegracaoID.Socinal
            ) {
              this.isSocinal = true;
              await this.getContratoCCBSocinal(pessoa);
            }
          }
        } else {
          this.attachments.push({
            item: { content: contratoOferta, name: "Contrato da Oferta" },
            url: "",
            tipo: "editor",
            parseRef: "parsedContentContratoOferta"
          });
          this.isLoading = false;
        }
      }
    },
    async getTermosRisco(pessoa) {
      /**
       * Termos de Risco
       */
      const publicSettings = await settingsService.getPublicSettings();

      const razaoSocial = this.financing.dados_complementares.empresa.nome;
      const dataEncerramentoOferta = moment(
        this.financing.fields["Encerramento da Oferta"].value
      ).format("DD/MM/YYYY");

      var outrasPlataformas = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_outras_plataformas
      );
      var nestaPlataforma = toNumberSafe(
        pessoa.dados_complementares?.perfil?.investimentos_nesta_plataforma
      );

      const montantePreFormatado = parseFloat(
        outrasPlataformas + nestaPlataforma
      )
        .toFixed(2)
        .replace(".", ",");
      const montante =
        "R$ " +
        montantePreFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      if (publicSettings.terms && publicSettings.terms.termo_ciencia_risco) {
        const replacements = {
          "#data": this.dataAtual,
          "#dt_atual": this.dataAtual,
          "#oferta_encerramento": dataEncerramentoOferta,
          "#local": pessoa.endereco.cidade,
          "#nomeInvestidor": pessoa.nome,
          "#cpfInvestidor": pessoa.documento.numero,
          "#razaoSocialEmissor": razaoSocial,
          "#montante": montante
        };
        const termoCienciaRisco = replaceKeywords(
          publicSettings.terms.termo_ciencia_risco,
          replacements
        );

        this.attachments.push({
          item: {
            content: termoCienciaRisco,
            name: "Termo de Ciência de Risco"
          },
          url: "",
          tipo: "editor",
          parseRef: "parsedContentTermoCienciaRisco"
        });
      }
    },
    nextStep() {
      this.uploadDocumentos();
    },
    async getURL(name) {
      const url = await attachmentService.urlAttachment(
        name,
        "InvestmentTerms"
      );

      return url;
    },

    pdfContratoCCBGenerated(pdfString) {
      if (this.is_admin) {
        this.order_admin.contrato_string = pdfString;
      } else {
        this.order.ccb.simulacao_contrato_string = pdfString;
        this.isLoading = false;
      }
    },

    async uploadContrato_ADMIN() {
      let order = this.order_admin;

      var storageRef = "ContratosCCB/";
      storageRef + order.pessoa.documento.numero;
      var fileName = order.ccb.simulacao.numero_ccb + "_" + "ContratoCCB.pdf";
      let response = await attachmentsService.addNewAttachment(
        order.contrato_string,
        fileName,
        storageRef
      );
      this.stopControl = false;

      if (this.zerar_contrato) {
        this.objetoContratoCCB = {
          ecwl_aporte: {},
          simulacao: {
            parcelas: {}
          },
          ecwl_oferta: {},
          credor: {},
          emitente: {},
          contrato: {}
        };
      }
    },

    async uploadContrato_ADMIN_2() {
      // var storageRef = "ContratosCCB/";
      // storageRef + order.pessoa.documento.numero;
      // var fileName = order.ccb.simulacao.numero_ccb + "_" + "ContratoCCB.pdf";
      // let response = await attachmentsService.addNewAttachment(order.contrato_string, fileName, storageRef);
      // console.log(response);
    },

    async getDisclaimerTermos() {
      const privateSettings = await settingsService.getPrivateSettings();

      if (
        privateSettings.integracao &&
        privateSettings.integracao.socinal &&
        privateSettings.integracao.socinal.enabled
      ) {
        this.disclaimerLabelTaxaAdministrativa =
          privateSettings.integracao.socinal.disclaimer_termos_label_taxa_administrativa;
        this.disclaimerLabelValorAportado =
          privateSettings.integracao.socinal.disclaimer_termos_label_valor_aportado;
        this.disclaimerLabelValorAporte =
          privateSettings.integracao.socinal.disclaimer_termos_label_valor_aporte;
        this.disclaimerLabelValorBrutoConsiderado =
          privateSettings.integracao.socinal.disclaimer_termos_label_valor_bruto_considerado;
        this.disclaimerValueValorAporte =
          privateSettings.integracao.socinal.disclaimer_termos_value_valor_aporte;

        this.disclaimerValueTaxaAdministrativa =
          privateSettings.integracao.socinal.disclaimer_termos_value_taxa_administrativa;
        this.disclaimerValueValorAportado = this.order.item.order.totalValue;
        this.disclaimerValueValorBrutoConsiderado = this.getValorAporte;

        this.showDisclaimer = true;
      }
    },

    generateHashAssinatura() {
      return uuid.v4();
    },

    async uploadDocumentosCallback(base64, filename) {
      let documento = this.order.user.documento.numero
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      var storageRef =
        "TermosAporte/" +
        this.order.item.id +
        "/" +
        documento +
        "/" +
        this.hashAssinatura +
        "/";
      let response = await attachmentsService.addNewAttachment(
        base64,
        filename,
        storageRef
      );

      if (response.state != "success") {
        this.$toasted.show(
          "Ocorreu um erro no aceite dos termos. Por favor, entre em contato com a plataforma.",
          {
            icon: "times",
            className: "error"
          }
        );
        this.isLoading = false;
      }
      this.termosUploaded = this.termosUploaded + 1;
      if (this.termosUploaded == this.termosParaUpload) {
        let that = this;
        try {
          await fetch("https://api.ipify.org?format=json")
            .then(x => x.json())
            .then(({ ip }) => {
              that.order.aceite_termos_hash = that.hashAssinatura;
              that.order.investidor_ip = ip;
              that.$emit("nextStep");
              that.isLoading = false;
            });
        } catch (e) {
          that.hasError = true;
          that.$toasted.show(
            "Ocorreu um erro na simulação. Por favor, entre em contato com a plataforma.",
            {
              icon: "times",
              className: "error"
            }
          );
          that.isLoading = false;
        }
      }
    },

    async uploadDocumentos() {
      this.isLoading = true;
      let index = 0;
      let that = this;

      // Filtra os anexos do tipo 'editor'
      let anexosFiltrados = this.attachments.filter(
        item => item.tipo == "editor"
      );
      this.termosParaUpload = anexosFiltrados.length;

      for (const attachment of anexosFiltrados) {
        // Gera o PDF e obtém a URL do PDF gerado (não gera download)
        const pdfUrl = await that.createPDF(
          attachment.item.name,
          "#contrato_" + index,
          false
        );

        // Verifica se o PDF foi gerado com sucesso antes de tentar fazer o upload
        if (pdfUrl) {
          // Faz o upload do PDF (a função `uploadDocumentosCallback` ou similar pode ser usada aqui)
          that.uploadDocumentosCallback(pdfUrl, attachment.item.name);
        } else {
          console.error(
            "Erro ao gerar o PDF para o anexo:",
            attachment.item.name
          );
        }

        index++;
      }

      this.isLoading = false;
    },

    // Função para converter o Blob em base64
    async blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]); // Pega a parte base64 da URL
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    async createPDF(name, selector, isDownload = true) {
      const element = document.querySelector(selector);

      if (!element) {
        console.error("Elemento do contrato não encontrado!");
        return null; // Retorna null se não encontrar o elemento
      }

      // Verifica se o PDF já foi gerado anteriormente e está armazenado no cache
      if (this.pdfCache[name]) {
        console.log(`PDF para ${name} já gerado, reutilizando.`);
        // Se o PDF já foi gerado, retorna a URL armazenada
        return this.pdfCache[name];
      }

      // Captura o conteúdo do elemento
      const bodyContent = element.outerHTML;

      // Define o HTML completo com head, styles e tags body
      const htmlContent = `
    <!DOCTYPE html>
    <html lang="pt-br">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>PDF Content</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@1.3.7/dist/quill.core.css">
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@1.3.7/dist/quill.snow.css">
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/quill@1.3.7/dist/quill.bubble.css">
      </head>
      <body>
        <div class="ql-editor contrato-ccb-parent">
          ${bodyContent}
        </div>
      </body>
    </html>
  `;

      try {
        // Chama o middleware passando os parâmetros necessários
        console.log("Iniciando geração do PDF");
        const pdfBuffer = await generatePDF(htmlContent, name); // Aqui chamamos o middleware e esperamos um buffer (PDF)

        // Cria um Blob a partir do buffer retornado (caso seja binário)
        const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

        // Converte o Blob para base64
        const base64Pdf = `data:application/pdf;base64,${await this.blobToBase64(
          pdfBlob
        )}`;

        // Cria a URL do PDF
        const pdfUrl = window.URL.createObjectURL(pdfBlob);

        // Armazena o PDF gerado no cache para uso futuro
        this.pdfCache[name] = base64Pdf;

        if (isDownload) {
          // Se for para download, cria o link e inicia o download
          const a = document.createElement("a");
          a.href = pdfUrl;
          a.download = `${name}.pdf`;
          a.click();
          window.URL.revokeObjectURL(pdfUrl);
          return null; // Não retorna nada quando for download
        } else {
          // Retorna o PDF URL para uso posterior (caso não seja download)
          return base64Pdf;
        }
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
        return null; // Retorna null em caso de erro
      }
    },
    async createPDFOld(name, selector) {
      const doc = new jsPDF("p", "pt", "A4");
      doc.html(document.querySelector(selector), {
        callback: function(doc) {
          doc.save(name + ".pdf");
        },
        margin: [30, 20, 30, 20],
        autoPaging: "text",
        width: 1024,
        height: 842,
        windowWidth: 1024,
        html2canvas: {
          scale: 0.55
        }
      });
    }
  }
};
</script>

<template>
  <div class="terms-of-use">
    <button
      class="btn btn-primary"
      type="button"
      v-if="is_admin"
      @click="regerarContrato_ADMIN"
    >
      GERAR CONTRATO
    </button>

    <button
      class="btn btn-primary"
      type="button"
      v-if="is_admin"
      @click="uploadContrato_ADMIN"
    >
      UPLOAD CONTRATO
    </button>

    <button
      class="btn btn-primary"
      type="button"
      v-if="is_admin"
      @click="generatePdfTermoUso"
    >
      TERMO DE USO PDF
    </button>

    <contrato-modelo
      v-if="is_admin && order_admin"
      :objeto="objetoContratoCCB"
      @pdfContratoCCBGenerated="pdfContratoCCBGenerated"
    />

    <div v-if="is_admin">
      <termo-uso-modelo
        v-for="(objetoTermoUso, index) in pdfTermosUsoLista"
        :key="index"
        :objeto="objetoTermoUso"
        @uploadTermoUso_ADMIN="uploadTermoUso_ADMIN"
      />
    </div>

    <br />
    <br />

    <p v-if="!is_admin && showDisclaimer">
      <b>{{ disclaimerLabelValorAporte }}</b> {{ disclaimerValueValorAporte }}
      <br />
      <b>{{ disclaimerLabelValorAportado }}</b>
      {{ disclaimerValueValorAportado | currency }} <br />
      <b>{{ disclaimerLabelTaxaAdministrativa }}</b>
      {{ disclaimerValueTaxaAdministrativa | currency }} <br />
      <b>{{ disclaimerLabelValorBrutoConsiderado }}</b>
      {{ disclaimerValueValorBrutoConsiderado | currency }}
    </p>
    <h4 v-if="!is_admin">Termos de Uso e Termo de adesão e ciência de risco</h4>
    <p v-if="!is_admin">
      Clique nos termos abaixo para visualizá-los:
    </p>

    <div v-if="!is_admin" class="loading-spinner">
      <double-bounce v-if="isLoading"></double-bounce>
    </div>

    <div v-if="!is_admin" class="attachment-list" :hidden="isLoading">
      <div
        class="attachment-item"
        v-for="(attachment, index) in attachments"
        :key="index"
      >
        <h5 v-b-toggle="`accordion-${index}`">
          {{ attachment.item.name }}
          <span>
            <i class="fas fa-angle-down"></i>
          </span>
        </h5>

        <b-collapse
          :id="`accordion-${index}`"
          :visible="visible"
          accordion="my-accordion"
          role="tabpanel"
        >
          <vue-pdf-viewer
            v-if="attachment.tipo == 'pdf'"
            width="100%"
            height="500px"
            :url="attachment.url"
          ></vue-pdf-viewer>
          <div
            style="border: 1px solid #555; padding: 5px; overflow-y: auto; height: 400px;"
          >
            <div
              v-if="financing.content"
              class="ql-container ql-snow"
              style="border: 0px !important;"
            >
              <div class="ql-editor contrato-ccb-parent">
                <button
                  class="btn btn-primary btn-download"
                  v-if="attachment.tipo == 'editor'"
                  @click="createPDF(attachment.item.name, '#contrato_' + index)"
                >
                  DOWNLOAD
                  <i class="fas fa-download"></i>
                </button>

                <div
                  class="contratos"
                  :id="'contrato_' + index"
                  v-if="attachment.tipo == 'editor'"
                  v-html="attachment.item.content"
                ></div>

                <div class="contratos" v-if="attachment.tipo == 'contrato-ccb'">
                  <contrato-modelo-socinal
                    v-if="isSocinal"
                    :objeto="objetoContratoCCB"
                    @pdfContratoCCBGenerated="pdfContratoCCBGenerated"
                  />
                  <contrato-modelo
                    v-else
                    :objeto="objetoContratoCCB"
                    @pdfContratoCCBGenerated="pdfContratoCCBGenerated"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <form
      @submit.prevent="nextStep()"
      v-if="!hasError && !isLoading && !is_admin"
    >
      <p>
        Para dar continuidade ao processo, você deve aceitar os termos:
      </p>

      <div class="terms-accepted" v-if="submodalidade == 'bacen'">
        <input type="checkbox" required v-model="termsAccepted" />
        <label for="">
          Declaro que li e estou de acordo com todos os termos acima. <br />
          Após confimar a condição de pagamento será enviado um contrato via
          Clicksign para assinatura. <br />
          Meu aporte somente será válido após o pagamento e assinatura do
          contrato via Clicksign.
        </label>
      </div>

      <div class="terms-accepted" v-if="submodalidade == '588'">
        <input type="checkbox" required v-model="termsAccepted" />
        <label for="">
          Declaro que li e estou de acordo com todos os termos acima.
        </label>
      </div>

      <div class="terms-button">
        <button
          :class="{ 'is-disabled': !termsAccepted }"
          class="button"
          type="submit"
        >
          Prosseguir
        </button>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.contrato-ccb-parent {
  background-color: rgba(0, 0, 0, 0.7);
  padding: 50px;
}
.contratos {
  width: 100%;
  background: #fff;
  padding: 20px; /* Adicionado espaçamento para evitar cortes no conteúdo */
  box-sizing: border-box;
}
.btn-download {
  right: 50px;
  position: absolute;
  top: 10px;
}
</style>
